import {Component, OnInit, OnDestroy} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, UntypedFormArray} from '@angular/forms';
import {UserService} from 'src/app/services/user/user.service';
import {Router} from '@angular/router';
import {AlertService} from 'src/app/services/alert/alert.service';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {User} from 'src/app/services/user/user';
import {takeWhile} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs';
import {UserPreference} from './user-preference';
import {UserPreferencesService} from 'src/app/services/user-preferences/user-preferences.service';
import {PrefItem} from './pref-item';

@Component({
    selector: 'app-user-preferences',
    templateUrl: './user-preferences.component.html',
    styleUrls: ['./user-preferences.component.css'],
    standalone: false
})
export class UserPreferencesComponent implements OnInit, OnDestroy {
  currentUser: User;
  tmssloader: any;
  private observer$ = new BehaviorSubject(true);
  userPreferencesAdminForm: UntypedFormGroup;
  userPref: UserPreference;
  userPrefList: PrefItem[];
  saveBtnDisable: boolean;

  constructor(private fb: UntypedFormBuilder,
              private userService: UserService,
              private userPreferencesService: UserPreferencesService,
              private router: Router,
              private alertService: AlertService,
              private loader: LoadingService) {
    this.tmssloader = this.loader;
    this.userService.getCurrentUserObservable().pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.currentUser = currentUser;
    });
  }

  ngOnInit(): void {
    this.userPreferencesAdminForm = this.fb.group({
      screenName: new UntypedFormControl(null),
      prefs: new UntypedFormArray([]),
    });
    this.saveBtnDisable = false;
    console.log('sy user pref ng on init');
    console.log(this.currentUser);
  }

  screenNameChange($event) {
    console.log('sy on screen name change');
    console.log($event.target.value);
    this.saveBtnDisable = true;
    const userId = this.currentUser.userSessionEntity.userId;
    const orgId = this.currentUser.userSessionEntity.organizationId;
    const screenName = $event.target.value;
    this.userPreferencesService.getUserPrefs(userId, orgId, screenName).subscribe(result => {
      this.userPref = result;
      console.log(this.userPref);
      this.userPrefList = this.userPref.listPrefs;
    });
  }

  onCheckboxChange(name: string, isChecked: boolean) {
    this.userPrefList.forEach(item => {
      if (item.headerName === name) {
        item.isVisible = isChecked;
      }
    });
  }

  savePref() {
    console.log('sy save pref');
    console.log(this.userPrefList);
    this.loader.show();
    this.userPreferencesService.saveUserPrefs(this.userPref).subscribe(
      result => {
        console.log(result);
        this.alertService.success('Your HHG query result preferences have been saved successfully. ');
        this.loader.hide();
      }, error => {
        this.alertService.error('Error while storing your HHG query  preferences.');
        this.loader.hide();
      });
  }

  ngOnDestroy() {
    this.observer$.next(false);
  }
}
